<template>
    <BaseModalWithLogo class="schedule-a-call-popup">
        <span class="schedule-a-call-popup__title">We are here to help!</span>
        <p class="schedule-a-call-popup__description1">Our experts can identify the keywords your site ranks for and
            import them into your project. Schedule a call with us, and we'll be happy to help!</p>
        <p class="schedule-a-call-popup__description2">
            Contact 
            <a target="_blank" href="mailto:support@audiencekey.com"
                class="schedule-a-call-popup__mail-link">support@audiencekey.com</a> 
            to request this, or schedule a call, and we’ll sort it out quickly.
        </p>
        <BaseButton class="schedule-a-call-popup__button"
            button-style="dark-gray"
            button-size="large"
            @click="scheduleCall">
            Schedule a call
            <BaseMaterialDesignIcon icon="openInNew"
                class="schedule-a-call-popup__button-icon" />
        </BaseButton>
        <router-link to="/strategy/keyword-census#add-keywords"
            @click.native="close"
            class="schedule-a-call-popup__manual-link">I’ll manually add keywords</router-link>
    </BaseModalWithLogo>
</template>

<script>
import BaseModalWithLogo from '@/common/BaseModalWithLogo.vue'
import { RouterLink } from 'vue-router';
export default {
    name: 'ScheduleACallPopup',
    components: {
        BaseModalWithLogo,
        RouterLink
    },
    methods: {
        scheduleCall() {
            // in new tab
            window.open('https://calendly.com/audiencekey/30min', '_blank');
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
.schedule-a-call-popup {
    padding: 80px 48px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-sizing: border-box;

    &__title {
        font-size: 28px;
        font-weight: 600;
        color: $rfx-text-dark-high-contrast;
    }

    &__description1,
    &__description2 {
        font-size: 20px;
        font-weight: 400;
        line-height: 150%;
        color: $rfx-text-dark-mid-contrast;
        margin: 0;
    }

    &__description2 {
        margin-top: 5px;
    }

    &__mail-link {
        color: $rfx-text-dark-high-contrast;

        &:hover {
            text-decoration: none;
        }
    }

    &__button {
        align-self: center;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 20px !important;
        padding: 9px 32px;
        font-weight: 400;
        margin-top: 16px;
    }

    &__button-icon {
        font-size: 20px;
        color: white;
    }

    &__manual-link {
        align-self: center;
        font-size: 16px;
        color: $rfx-text-dark-high-contrast;
        text-decoration: none;
        padding-bottom: 8px;

        &:hover {
            text-decoration: underline;
        }
    }
    
}
</style>